import { render, staticRenderFns } from "./password-reset.vue?vue&type=template&id=9e2229fa"
import script from "./password-reset.vue?vue&type=script&setup=true&lang=ts"
export * from "./password-reset.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports